import { render, staticRenderFns } from "./MeasurementChart.vue?vue&type=template&id=138d01c8&scoped=true&"
import script from "./MeasurementChart.vue?vue&type=script&lang=js&"
export * from "./MeasurementChart.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementChart.vue?vue&type=style&index=0&id=138d01c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d01c8",
  null
  
)

export default component.exports